import { render, staticRenderFns } from "./proveedoresERP.vue?vue&type=template&id=b05ca50a&scoped=true"
import script from "./proveedoresERP.vue?vue&type=script&lang=js"
export * from "./proveedoresERP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05ca50a",
  null
  
)

export default component.exports